import { useEffect } from 'react';
import { noop } from 'lodash';
import {
    markFibMigrationMounted,
    OpenFibMigrationEventDetails,
    OpenFibMigrationEvent,
    removeEventHandler,
    setupEventHandler,
} from '../UserMigration/fib-migration-trigger';
import { countEventTrigger } from '../../events/countEvent';
import { SeamlessModalPayloadValue } from './triggers';
import { ModalType } from './types';

const defaultModalProps: OpenFibMigrationEventDetails & { source?: string; isOpen?: boolean } = {
    source: 'default',
    withSkipAction: true,
    isOpen: false,
    flowContext: {} as OpenFibMigrationEventDetails['flowContext'],
    redirectCtaData: undefined,
    onSuccess: noop,
    onError: noop,
    onLoadError: noop,
    onSkip: noop,
    biEnrichment: {} as OpenFibMigrationEventDetails['biEnrichment'],
};

/**
 * Handle "../UserMigration/fib-migration-trigger.ts" and "../SeamlessProMigrationModalManager/utils.ts"
 */
export const useOldModalMigrationEvents = ({
    setModalProps,
    setModalType,
}: {
    setModalProps(data: SeamlessModalPayloadValue): any;
    setModalType(type: ModalType): void;
}) => {
    // Listen legacy full user migration modal
    useEffect(() => {
        const handlePopupEvent = (event: OpenFibMigrationEvent) => {
            const {
                withSkipAction,
                flowContext,
                redirectCtaData,
                onSuccess,
                onError,
                onSkip,
                onLoadError = noop,
                source,
                biEnrichment,
            } = event.detail || defaultModalProps;

            setModalType(ModalType.FullMigration);
            setModalProps({
                withSkipAction,
                onSuccess,
                onError,
                onSkip,
                onLoadError,
                source,
                isOpen: true,
                redirectCtaData,
                biEnrichment: { ...biEnrichment },
                flowContext,
            } as any);

            countEventTrigger({ metric: 'legacy_modal_opened', type: ModalType.FullMigration, source });
        };
        setupEventHandler(handlePopupEvent);
        markFibMigrationMounted(true);

        return () => {
            removeEventHandler(handlePopupEvent);
            markFibMigrationMounted(false);
        };
    }, [setModalType, setModalProps]);
};
